// extracted by mini-css-extract-plugin
export var newsLetter = "newsletter-module--newsLetter--QiAmW";
export var signUpForm = "newsletter-module--signUpForm--SCz15";